import React from 'react'
import { formatPlural } from '@dostavkee/web-ui'
import dayjs from 'dayjs'
import { toast } from 'sonner'

import { type ErrorStruct, getRecruitmentCheckLimit } from '@/shared/api'
import { getErrorMessage } from '@/shared/model'

export const getCheckLimit = async () => {
    try {
        const response = await getRecruitmentCheckLimit()

        const { success, limit_count, limit_period } = response

        const isReachedLimit = !success

        const formattedLimitCount = formatPlural(limit_count, {
            zero: 'заявок',
            one: 'заявка',
            two: 'заявки',
            few: 'заявок',
            many: 'заявок',
            other: 'заявок',
        })

        const formattedLimitPeriod = dayjs.duration({ hours: limit_period }).humanize()

        return {
            isReachedLimit,
            formattedLimitCount,
            formattedLimitPeriod,
        }
    } catch (error) {
        if (error) {
            const { error_code } = error as ErrorStruct
            toast.error(getErrorMessage(error_code))
        } else {
            toast.error(`Ошибка при проверке лимита заявок. Неизвестная ошибка`)
        }
        throw error
    }
}

export const useRecruitmentCheckLimit = () => {
    const [isPending, setIsPending] = React.useState(false)

    const checkLimit = async () => {
        setIsPending(true)
        try {
            const response = await getCheckLimit()

            return response
        } finally {
            setIsPending(false)
        }
    }

    return {
        checkLimit,
        isPending,
    }
}
